var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Panel',{attrs:{"footer":false},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h3',[_vm._v("Histórico")])]},proxy:true}])},[_c('div',[_c('strong',[_vm._v("Informação")]),_vm._v(" Em desenvolvimento")])])}
var staticRenderFns = []

export { render, staticRenderFns }